export default __webpack_public_path__ + "static/media/snow_evening.6454059e.svg";